import {ChangeDetectionStrategy, Component, Injector} from '@angular/core';
import {
  CorePortalEntityEditBaseComponent,
  CorePortalFormlyReadonlyTypes,
  CorePortalFormlyReadonlyTyping
} from '@app/core-portal';
import {FormlyFieldConfig} from '@ngx-formly/core';
import {InvitationDto, InvitationPurpose, InvitationType} from "@app/core-shared";
import {
  invitationPurposeEnumOptions,
  invitationTypeEnumOptions
} from "../../models";

@Component({
  selector: 'app-settings-invitations-edit',
  templateUrl: './invitations-edit.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class CorePortalFeatureInvitationsEditComponent extends CorePortalEntityEditBaseComponent<InvitationDto> {
  constructor(
    protected injector: Injector,
  ) {
    super(injector);
  }

  /* istanbul ignore next */
  protected createForm(): FormlyFieldConfig[] {
    return [
      {
        key: 'name',
        type: 'input',
        wrappers: ['core-portal-translated'],
        className: 'col-md-12',
        props: {
          corePortalTranslated: {
            label: 'core-shared.shared.fields.name',
            validationMessages: {
              required: 'core-portal.core.validation.required'
            }
          },
          type: 'text'
        },
        expressions: {
          hide: () => !this.creating,
          'props.required': () => !this.readonly,
          'props.disabled': () => this.readonly
        },
      },
      {
        key: 'purpose',
        type: 'core-portal-ng-select',
        wrappers: ['core-portal-translated', 'core-portal-readonly'],
        className: 'col-md-6',
        defaultValue: InvitationPurpose.Team,
        props: {
          corePortalTranslated: {
            label: 'core-shared.shared.fields.purpose',
            validationMessages: {
              required: 'core-portal.core.validation.required'
            }
          },
          corePortalReadonly: {
            type: CorePortalFormlyReadonlyTypes.ENUM,
            enumOptions: invitationPurposeEnumOptions,
            translate: true
          } as CorePortalFormlyReadonlyTyping,
          corePortalNgSelect: {
            items: invitationPurposeEnumOptions,
            translate: true
          }
        },
        expressions: {
          'props.required': () => !this.readonly,
          'props.disabled': () => this.readonly
        },
      },
      {
        key: 'type',
        type: 'core-portal-ng-select',
        wrappers: ['core-portal-translated', 'core-portal-readonly'],
        className: 'col-md-6',
        defaultValue: InvitationType.Identify,
        props: {
          corePortalTranslated: {
            label: 'core-shared.shared.fields.type',
            validationMessages: {
              required: 'core-portal.core.validation.required'
            }
          },
          corePortalReadonly: {
            type: CorePortalFormlyReadonlyTypes.ENUM,
            enumOptions: invitationTypeEnumOptions,
            translate: true
          } as CorePortalFormlyReadonlyTyping,
          corePortalNgSelect: {
            items: invitationTypeEnumOptions,
            translate: true
          }
        },
        expressions: {
          'props.required': () => !this.readonly,
          'props.disabled': () => this.readonly
        },
      },
      {
        key: 'code',
        type: 'input',
        wrappers: ['core-portal-translated', 'core-portal-readonly'],
        className: 'col-md-6',
        props: {
          corePortalTranslated: {
            label: 'core-shared.shared.fields.invitation-code',
            validationMessages: {
              required: 'core-portal.core.validation.required'
            }
          },
          corePortalReadonly: {
            type: CorePortalFormlyReadonlyTypes.BASIC
          } as CorePortalFormlyReadonlyTyping,
          type: 'text'
        },
        expressions: {
          hide: () => this.creating,
          'props.required': () => false,
          'props.readonly': () => true
        },
      },
      {
        key: 'isRevoked',
        type: 'core-portal-switch',
        wrappers: ['core-portal-translated', 'core-portal-readonly'],
        defaultValue: false,
        className: 'col-md-6',
        props: {
          corePortalReadonly: {
            type: CorePortalFormlyReadonlyTypes.BOOLEAN
          } as CorePortalFormlyReadonlyTyping,
          corePortalTranslated: {
            label: 'core-shared.shared.fields.is-revoked',
            validationMessages: {
              required: 'core-portal.core.validation.required'
            }
          },
          type: 'text'
        },
        expressions: {
          hide: () => this.creating,
          'props.required': () => false,
          'props.readonly': () => true
        },
      }
    ];
  }
}
